import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./auth/AuthContext";
import { FeatureFlagsProvider } from "./contexts/FeatureFlagsContext";
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <AuthProvider>
      <FeatureFlagsProvider>
        <App />
      </FeatureFlagsProvider>
    </AuthProvider>
  </React.StrictMode>,
);
